/**
 * TradingMovedBanner — one-line notice that order execution moved to the
 * desktop Quantum Terminal. Shown only when SITE_TRADING_ENABLED is false
 * (the default after the merge). Dismissible per browser.
 *
 * The web app keeps everything analytical: charts, screener, radar, intel,
 * the position-size calculator, situations, the trade journal. It just no
 * longer places orders — that path is blocked at the data layer
 * (utils/binance.js, utils/exchangeTrading.js) and this explains why.
 */
import { useState } from 'react';
import { SITE_TRADING_ENABLED } from '../config';
import { tr, Button } from '@quantum/ui';

const KEY = 'quantum.tradingMovedBannerDismissed';

export default function TradingMovedBanner() {
  const [dismissed, setDismissed] = useState(() => {
    try { return localStorage.getItem(KEY) === '1'; } catch { return false; }
  });

  if (SITE_TRADING_ENABLED || dismissed) return null;

  return (
    <div
      role="status"
      style={{
        // A floating notice at the bottom: a top bar sat on the landing nav (its
        // Dismiss covered Sign in) and the app header.
        position: 'fixed', bottom: 14, left: '50%', transform: 'translateX(-50%)', zIndex: 'var(--z-dropdown)',
        maxWidth: 'min(720px, calc(100vw - 32px))',
        display: 'flex', alignItems: 'center', gap: 10,
        padding: '8px 12px 8px 14px', borderRadius: 12,
        boxShadow: 'var(--shadow-float)',
        background: 'var(--s3)',
        color: 'var(--hi, var(--hi))',
        font: "500 var(--fs-sm)/1.4 var(--font-ui, 'Inter', system-ui, sans-serif)",
      }}
    >
      <span style={{ color: 'var(--acc, var(--info))' }}>⬗</span>
      <span style={{ flex: 1 }}>
        {tr('Order execution has moved to the')} <strong>Quantum Terminal</strong> {tr('desktop app. This web app is for analysis, charting and position sizing.')}
      </span>
      <Button variant="ghost" size="sm" onClick={() => {
        try { localStorage.setItem(KEY, '1'); } catch { /* private mode */ }
        setDismissed(true);
      }}>{tr('Dismiss')}</Button>
    </div>
  );
}
